export default __webpack_public_path__ + "static/media/NeoNX110_Frente.23c0ffe0.webp";